import { patterns } from '../settings';
import { toASCII } from 'punycode/';

const transformDomainToAscii = (email: string) => {
    try {
        const [localPart, domain] = email.split('@');
        const transformedDomain = toASCII(domain);
        return `${localPart}@${transformedDomain}`;
    } catch {
        throw new Error(`Could not ascii-transform domain of email "${email}`);
    }
};

export const isEmail = (value: string) => patterns.EMAIL_STRING.test(value);
export const isRFC5322Email = (value: string) => {
    try {
        const transformedEmail = transformDomainToAscii(value);
        return isEmail(transformedEmail);
    } catch {
        return false;
    }
};
